/*
  QBounce cart and kits (Theme settings > QBounce cart and kits). Loaded on every page by qb-revamp-head.
  1. Cart drawer (qb_cart): "Add" on the suggested products, redraws the drawer in place.
  2. App access card on product pages (qb_app_card): ticked = "VIP Price", unticked = "Guest Price". Sets the hidden
     "User Type" choice in every Kaching bundle bar and in the theme's own option picker, and moves cart lines of the
     other type over (VIP and Guest are never mixed in one cart, as with the drawer switch it replaces).
  3. Kit pictures in the Kaching bars (qb_kits): a bar whose text names two or more kinds of item ("Ball + Mat",
     "2 Balls + 2 Mats + FREE WALL HOOP", "Punching Bag + Included Pump") gets one small photo per item, with the
     count and a FREE tag where the text says so; plus the app (its "1 mo free" tag while the app card is ticked).
     Balls and mats follow the sizes picked in the bar.
  4. Option buttons in the Kaching bars (qb_bundle_buttons): sizes and colours as buttons instead of dropdowns.
*/
(function () {
  'use strict';
  if (window.qbCartReady) return;
  window.qbCartReady = true;

  var VIP = 'VIP Price';
  var GUEST = 'Guest Price';
  /* on the store the VIP price is called "w App" ("W App" on one product): typeOf() maps an option value to VIP or
     GUEST (null for anything else), sameAs() puts a variant title in those terms so titles can be compared */
  function typeOf(v) {
    v = (v || '').trim();
    if (/^w app$/i.test(v)) return VIP;
    return v === GUEST ? GUEST : null;
  }
  function sameAs(title) {
    return (title || '').split(' / ').map(function (x) { return typeOf(x) || x; }).join(' / ');
  }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SECTIONS = 'cart-drawer,cart-icon-bubble';

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.status) throw j;
        return j;
      });
    });
  }

  function drawerEl() {
    return document.querySelector('cart-drawer');
  }

  /* Redraw the drawer from a section render (the same parts the theme swaps after Add to cart), keep it open or
     closed as asked, and keep the price type the drawer reports in step */
  function redraw(sections, open) {
    var d = drawerEl();
    if (!d || !sections) return;
    var html = sections['cart-drawer'];
    if (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('cart-drawer');
      var inner = doc.querySelector('#CartDrawer');
      var mine = d.querySelector('#CartDrawer');
      if (inner && mine) mine.innerHTML = inner.innerHTML;
      if (fresh) {
        d.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
        if (fresh.dataset.qbType) d.dataset.qbType = fresh.dataset.qbType;
      }
      var overlay = d.querySelector('#CartDrawer-Overlay');
      if (overlay && d.close) overlay.addEventListener('click', d.close.bind(d));
    }
    var bubble = sections['cart-icon-bubble'];
    var holder = document.getElementById('cart-icon-bubble');
    if (bubble && holder) {
      var b = new DOMParser().parseFromString(bubble, 'text/html').querySelector('.shopify-section');
      if (b) holder.innerHTML = b.innerHTML;
    }
    if (open && d.open) d.open();
  }

  /* ---------- 0. no blink after Add to cart ----------
     The theme draws the drawer and opens it, then its cart-update listener (CartItems.onCartUpdate) fetches the
     drawer again ~0.4 s later and swaps in an identical copy. For this drawer: swap only when the cart differs
     (data-qb-sig: count, total, line keys and quantities); and entrance motions play only while it is opening. */
  function patchCartItems() {
    var C = window.customElements && customElements.get('cart-drawer-items');
    if (!C || C.prototype.qbPatched) return !!C;
    var orig = C.prototype.onCartUpdate;
    C.prototype.qbPatched = true;
    C.prototype.onCartUpdate = function () {
      if (!document.querySelector('cart-drawer.qb-cd')) return orig.apply(this, arguments);
      return fetch((window.routes && routes.cart_url ? routes.cart_url : '/cart') + '?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var html = new DOMParser().parseFromString(text, 'text/html');
          var cur = document.querySelector('cart-drawer-items');
          var fresh = html.querySelector('cart-drawer-items');
          if (cur && fresh && cur.dataset.qbSig && cur.dataset.qbSig === fresh.dataset.qbSig) return;
          ['cart-drawer-items', '.cart-drawer__footer'].forEach(function (sel) {
            var t = document.querySelector(sel), n = html.querySelector(sel);
            if (t && n) t.replaceWith(n);
          });
          /* the suggestions beside the cart (qb_cart_side) sit outside both; they come and go with the cart */
          var side = document.querySelector('cart-drawer .qb-cd__side'), nSide = html.querySelector('.qb-cd__side');
          var foot = document.querySelector('cart-drawer .drawer__footer');
          if (side && nSide) side.replaceWith(nSide);
          else if (side) side.remove();
          else if (nSide && foot) foot.before(nSide);
        })
        .catch(function (e) { console.error(e); });
    };
    return true;
  }
  if (!patchCartItems() && window.customElements) customElements.whenDefined('cart-drawer-items').then(patchCartItems);

  function watchOpening() {
    var d = drawerEl();
    if (!d || d.dataset.qbOpenWatch) return;
    d.dataset.qbOpenWatch = '1';
    var was = d.classList.contains('active'), t;
    new MutationObserver(function () {
      var now = d.classList.contains('active');
      if (now && !was && !d.classList.contains('qb-cd--in')) {
        d.classList.add('qb-cd--in');
        clearTimeout(t);
        t = setTimeout(function () { if (d.classList.contains('qb-cd--in')) d.classList.remove('qb-cd--in'); }, 1200);
      }
      /* only touch the class when it changes: removing a missing class still counts as a change and would loop */
      if (!now && d.classList.contains('qb-cd--in')) d.classList.remove('qb-cd--in');
      /* lets the page move floating widgets (the currency button) out of the cart's way */
      if (now !== was) document.documentElement.classList.toggle('qb-cart-open', now);
      was = now;
    }).observe(d, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchOpening);
  else watchOpening();

  /* ---------- 1. suggested products: Add ---------- */
  function pickVariant(btn) {
    var ids = (btn.dataset.variants || '').split(',');
    var titles = (btn.dataset.titles || '').split('|');
    var avail = (btn.dataset.avail || '').split(',');
    /* the button is drawn with the cart (Liquid), so its type is always the cart's current one */
    var type = btn.dataset.type || VIP;
    var pick = btn.closest('.qb-cd__rec') && btn.closest('.qb-cd__rec').querySelector('.qb-cd__rec-pick');
    function ok(i, wantType, wantPick) {
      if (avail[i] !== 'true') return false;
      var parts = (titles[i] || '').split(' / ');
      var types = parts.map(typeOf);
      if (wantType && types.indexOf(type) === -1 && (types.indexOf(VIP) > -1 || types.indexOf(GUEST) > -1)) return false;
      if (wantPick && pick && parts[Number(pick.dataset.index)] !== pick.value) return false;
      return true;
    }
    var tries = [[true, true], [true, false], [false, true], [false, false]];
    for (var t = 0; t < tries.length; t++) {
      for (var i = 0; i < ids.length; i++) if (ok(i, tries[t][0], tries[t][1])) return ids[i];
    }
    return ids[0];
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-qb-add]');
    if (!btn || btn.classList.contains('is-busy')) return;
    e.preventDefault();
    var recs = btn.closest('.qb-cd__recs');
    var err = recs && recs.querySelector('.qb-cd__rec-error');
    if (err) err.hidden = true;
    btn.classList.add('is-busy');
    btn.setAttribute('aria-busy', 'true');
    postJSON('/cart/add.js', {
      items: [{ id: Number(pickVariant(btn)), quantity: 1 }],
      sections: SECTIONS,
      sections_url: window.location.pathname
    })
      .then(function (j) {
        btn.classList.remove('is-busy');
        btn.classList.add('is-done');
        setTimeout(function () { redraw(j.sections, true); }, reduce ? 0 : 520);
      })
      .catch(function () {
        btn.classList.remove('is-busy');
        btn.removeAttribute('aria-busy');
        if (err) err.hidden = false;
      });
  });

  /* minus at quantity 1 removes the line (the theme's own check refuses 0 there and stops with an error) */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest && e.target.closest('cart-drawer.qb-cd .qb-cd__qty button[name="minus"]');
    if (!minus) return;
    var row = minus.closest('.qb-cd__item');
    var input = row && row.querySelector('.quantity__input');
    if (!input || Number(input.value) > 1) return;
    var rm = row.querySelector('cart-remove-button');
    if (!rm) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    rm.click();
  }, true);

  /* ---------- 2. app access card ---------- */
  function setCartType(type) {
    var other = type === VIP ? GUEST : VIP;
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var lines = cart.items.filter(function (i) { return sameAs(i.variant_title).split(' / ').indexOf(other) > -1; });
        if (!lines.length) return null;
        return Promise.all(lines.map(function (i) {
          return fetch('/products/' + encodeURIComponent(i.handle) + '.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (p) {
              var want = sameAs(i.variant_title).split(' / ').map(function (x) { return x === other ? type : x; }).join(' / ');
              var v = p.variants.find(function (x) { return sameAs(x.title) === want; });
              return v ? { key: i.key, id: v.id, quantity: i.quantity, properties: i.properties || {} } : null;
            })
            .catch(function () { return null; });
        })).then(function (swaps) {
          swaps = swaps.filter(Boolean);
          if (!swaps.length) return null;
          var updates = {};
          swaps.forEach(function (s) { updates[s.key] = 0; });
          return postJSON('/cart/update.js', { updates: updates }).then(function () {
            return postJSON('/cart/add.js', {
              items: swaps.map(function (s) { return { id: s.id, quantity: s.quantity, properties: s.properties }; }),
              sections: SECTIONS,
              sections_url: window.location.pathname
            });
          });
        });
      });
  }

  function scopeOf(card) {
    return card.closest('product-info, .product, .quick-add-modal__content') || document.documentElement;
  }

  function applyType(scope, type) {
    scope.querySelectorAll('.kaching-bundles select[data-name]').forEach(function (s) {
      if ((s.dataset.name || '').toLowerCase() !== 'user type') return;
      if (typeOf(s.value) === type) return;
      var has = Array.prototype.find.call(s.options, function (o) { return typeOf(o.value) === type; });
      if (!has) return;
      s.value = has.value;
      s.dispatchEvent(new Event('change', { bubbles: true }));
    });
    scope.querySelectorAll('variant-selects fieldset, variant-radios fieldset').forEach(function (fs) {
      var legend = fs.querySelector('legend');
      if (!legend || legend.textContent.trim().toLowerCase().indexOf('user type') !== 0) return;
      var input = Array.prototype.find.call(fs.querySelectorAll('input'), function (x) { return typeOf(x.value) === type; });
      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    scope.classList.toggle('qb-app-off', type !== VIP);
  }

  function initAppCard(card) {
    if (card.dataset.qbReady) return;
    card.dataset.qbReady = '1';
    var input = card.querySelector('.qb-appcard__input');
    var scope = scopeOf(card);
    var type = function () { return input.checked ? VIP : GUEST; };
    var busy = false;

    applyType(scope, type());
    kitTiles(scope);

    input.addEventListener('change', function () {
      var t = type();
      card.classList.toggle('is-on', input.checked);
      applyType(scope, t);
      kitTiles(scope);
      if (busy) return;
      busy = true;
      card.classList.add('is-busy');
      setCartType(t)
        .then(function (j) { if (j) redraw(j.sections, false); })
        .catch(function () {})
        .then(function () {
          busy = false;
          card.classList.remove('is-busy');
          /* the shopper may have flipped it again meanwhile */
          if (type() !== t) input.dispatchEvent(new Event('change'));
        });
    });

    /* Kaching draws its bars late and redraws them on each choice: keep the price type and the kit row in step */
    watchKaching(scope, function () {
      applyType(scope, type());
      kitTiles(scope);
    });
  }

  /* Calls fn (debounced) whenever the Kaching widget in scope changes: its parts, or a choice in it (Kaching keeps
     the chosen option in data-value; a size change alters nothing else). Watches only the widget once it exists (the
     page has other live parts, e.g. the countdown), the whole scope until then. */
  function watchKaching(scope, fn) {
    var timer, target = null;
    var mo = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        mo.disconnect();
        fn();
        listen();
      }, 90);
    });
    function listen() {
      var k = scope.querySelector('.kaching-bundles');
      target = k ? k.parentElement || k : scope;
      mo.observe(target, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-value'] });
    }
    listen();
  }

  /* ---------- 3. kit pictures in the bundle bars ---------- */
  var KINDS = [
    ['hoop', /\bwall\s*hoops?\b|\bhoops?\b/],
    ['socks', /\bsocks?\b/],
    ['bag', /\bpunching\s*bags?\b/],
    ['pump', /\bpumps?\b/],
    ['mat', /\bmats?\b/],
    ['ball', /\b(?:basket|soccer\s+|foot)?balls?\b/]
  ];

  function parseKit(text, items) {
    var out = [];
    text.toLowerCase().split(/\+|&|,|\band\b/).forEach(function (seg) {
      KINDS.forEach(function (k) {
        if (!items[k[0]] || !k[1].test(seg)) return;
        if (out.some(function (o) { return o.key === k[0]; })) return;
        var n = seg.match(/(\d+)\s*(?:x\s*)?[a-z]/);
        out.push({ key: k[0], qty: n ? Number(n[1]) : 1, free: /\bfree\b/.test(seg) });
      });
    });
    return out;
  }

  /* one picture tile: the photo fills a rounded frame; tags sit on its edges (FREE / 1 mo free on top, the size
     along the bottom, the count in the corner). No visible name: the item is in the photo and in its alt text. */
  function tile(item, data, i) {
    var li = document.createElement('li');
    li.className = 'qb-kitrow__item' + (item.app ? ' qb-kitrow__item--app' : '');
    li.dataset.id = item.id;
    li.style.setProperty('--i', i);
    var pic = document.createElement('span');
    pic.className = 'qb-kitrow__pic';
    var img = document.createElement('img');
    img.src = data.img;
    img.width = 100;
    img.height = 100;
    img.loading = 'lazy';
    var frame = document.createElement('span');
    frame.className = 'qb-kitrow__img';
    frame.appendChild(img);
    pic.appendChild(frame);
    li.appendChild(pic);
    paint(li, item, data, true);
    return li;
  }

  /* smaller balls show a little smaller (a hint, not to scale), the Youth mat too */
  var SCALE = { 'size 7': 1, 'size 6': 0.92, 'size 5': 0.84, 'size 3': 0.76, youth: 0.88 };

  /* puts an item's tags, size, count and alt text on its tile. On a tile already shown a new tag pops in and a
     changed one bumps once, so a choice (app box, ball size) moves only the picture it is about. */
  function paint(li, item, data, fresh) {
    var pic = li.querySelector('.qb-kitrow__pic');
    var size = item.size != null ? item.size : data.size || '';
    li.querySelector('img').alt = (item.qty > 1 ? item.qty + ' x ' : '') + data.label + (size ? ', ' + size.toLowerCase() : '') + (item.tag ? ' (' + item.tag.toLowerCase() + ')' : '');
    var s = SCALE[size.toLowerCase()];
    if (s) li.style.setProperty('--qb-s', s);
    else li.style.removeProperty('--qb-s');
    [['qb-kitrow__tag', item.tag], ['qb-kitrow__size', size], ['qb-kitrow__qty', item.qty > 1 ? 'x' + item.qty : '']].forEach(function (c) {
      var el = pic.querySelector('.' + c[0]);
      if (!c[1]) {
        if (el) el.remove();
        return;
      }
      if (el && el.textContent === c[1]) return;
      var added = !el;
      if (added) {
        el = document.createElement('span');
        el.className = c[0];
        el.setAttribute('aria-hidden', 'true');
        pic.appendChild(el);
      }
      el.textContent = c[1];
      if (fresh || reduce || !el.animate) return;
      el.animate(added ? [{ opacity: 0, scale: '0.8' }, { opacity: 1, scale: '1' }] : [{ scale: '1' }, { scale: '1.18' }, { scale: '1' }], { duration: added ? 220 : 340, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' });
    });
  }

  /* what is picked in each row of a bar (Kaching repeats its pickers once per item, "#1", "#2"): the ball's size is
     the "Size 7" / "Size 7 (Standard)" value, the mat's is Standard / Youth */
  function rowSizes(bar, key) {
    var out = [];
    bar.querySelectorAll('.kaching-bundles__bar-variant-selector-wrapper .kaching-bundles__bar-variant-selects').forEach(function (g) {
      var found = null;
      ctlsOf(g).forEach(function (c) {
        var v = ctlValue(c);
        var m = v.match(/^size\s*(\d+)/i);
        if (key === 'ball' && m) found = 'Size ' + m[1];
        if (key === 'mat' && /^(standard|youth)$/i.test(v)) found = /youth/i.test(v) ? 'Youth' : '';
      });
      if (found !== null) out.push(found);
    });
    return out;
  }

  function kitTiles(scope) {
    var dataEl = scope.querySelector('script.qb-kit-data');
    if (!dataEl) return;
    var items;
    try { items = JSON.parse(dataEl.textContent || '{}'); } catch (e) { return; }
    /* the app tile stays whenever the product has the app card; only its "1 mo free" tag follows the tick (client) */
    var hasApp = !!scope.querySelector('[data-qb-appcard]');
    var appOn = hasApp && !scope.classList.contains('qb-app-off');
    scope.querySelectorAll('.kaching-bundles__bar').forEach(function (bar) {
      var main = bar.querySelector('.kaching-bundles__bar-main');
      var row = bar.querySelector('.qb-kitrow--bar');
      /* the tag and the subtitle list what is inside ("2 Balls + 2 Mats + FREE WALL HOOP", "Ball + Mat"); the
         title can be a product name ("QBounce Basketball Training Mat"), so it is not read */
      var parts = ['.kaching-bundles__bar-label', '.kaching-bundles__bar-subtitle'].map(function (s) {
        var el = bar.querySelector(s);
        return el ? el.textContent : '';
      });
      var list = bar.querySelector('.kaching-bundles__bundle-products') ? [] : parseKit(parts.join(' + '), items);
      if (!main || list.length < 2) {
        if (row) row.remove();
        return;
      }
      /* balls and mats follow the sizes picked in the bar: the same size for all = one picture with the count, two
         sizes = a picture each (Kit 1 Size 7, Kit 2 Size 5) */
      var tiles = [];
      list.forEach(function (it) {
        if (it.free) it.tag = 'Free';
        var sizes = it.key === 'ball' || it.key === 'mat' ? rowSizes(bar, it.key) : [];
        if (!sizes.length) {
          it.id = it.key;
          tiles.push(it);
          return;
        }
        var counts = {};
        var order = [];
        for (var n = 0; n < it.qty; n++) {
          var s = sizes[Math.min(n, sizes.length - 1)];
          if (!(s in counts)) {
            counts[s] = 0;
            order.push(s);
          }
          counts[s]++;
        }
        order.forEach(function (s, j) {
          tiles.push({ key: it.key, id: it.key + (j ? '-' + j : ''), qty: counts[s], tag: it.tag, size: s });
        });
      });
      if (hasApp && items.app) tiles.push({ key: 'app', id: 'app', qty: 1, tag: appOn ? '1 mo free' : '', app: true });
      /* the row is kept and updated tile by tile; only a new picture drops in */
      var fresh = !row || row.previousElementSibling !== main;
      if (fresh) {
        if (row) row.remove();
        row = document.createElement('ul');
        row.className = 'qb-kitrow qb-kitrow--bar';
        row.setAttribute('role', 'list');
        row.setAttribute('aria-label', 'In this kit');
        main.after(row);
      }
      var keep = {};
      tiles.forEach(function (it, i) {
        keep[it.id] = true;
        var li = Array.prototype.find.call(row.children, function (x) { return x.dataset.id === it.id; });
        if (li) paint(li, it, items[it.key], false);
        else li = tile(it, items[it.key], fresh ? i : 0);
        if (row.children[i] !== li) row.insertBefore(li, row.children[i] || null);
      });
      Array.prototype.slice.call(row.children).forEach(function (li) {
        if (!keep[li.dataset.id]) li.remove();
      });
      row.classList.toggle('qb-kitrow--many', tiles.length > 4);
    });
  }

  /* ---------- 4. option buttons in the Kaching bars (qb_bundle_buttons) ---------- */
  /* Kaching's dropdowns (ball size, mat size, sock colour, shorts size) become buttons that show every choice
     (Baymard: sizes behind a dropdown get missed). Kaching's own pickers stay in the page, hidden, and still do the
     work: a button sets its picker the way a shopper would (a <select> change; Kaching's picture dropdown opened and
     its option clicked). Long lists (Country) stay dropdowns. In a bar with one row per item, row 2 onwards starts
     as "Same as Kit 1" when it matches row 1, and follows row 1 while ticked. */
  var SZ = document.documentElement.classList.contains('qb-sz');
  /* the store's own names for the ball sizes (the silent basketball's Size option) */
  var BALL_NAMES = { 7: 'Standard', 6: "Women's", 5: 'Youth', 3: 'Toddler' };
  var SIZE_ORDER = ['xs', 's', 'small', 'm', 'medium', 'l', 'large', 'xl', '2xl', 'xxl', '3xl', 'xxxl'];
  var COLOURS = {
    black: '#111111', white: '#f2f2f2', red: '#d62828', blue: '#2563eb', yellow: '#facc15', purple: '#7c3aed',
    orange: '#ff7a1a', green: '#16a34a', pink: '#ec4899', grey: '#9ca3af', gray: '#9ca3af', navy: '#1e3a8a'
  };

  function ctlsOf(g) {
    return Array.prototype.filter.call(g.children, function (c) {
      return (c.tagName === 'SELECT' || c.classList.contains('kaching-bundles__swatch-dropdown')) && !/^user type$/i.test(c.dataset.name || '');
    });
  }

  function ctlValue(c) {
    return c.tagName === 'SELECT' ? c.value : c.dataset.value || '';
  }

  /* Kaching's picture dropdown lists its choices only while open and closes the others when one opens, so every
     open / pick on them runs one at a time */
  var queue = Promise.resolve();
  var queued = 0;
  function later(fn) {
    queued++;
    queue = queue.then(function () {
      return new Promise(function (done) {
        fn(function () {
          queued--;
          done();
        });
      });
    });
  }

  function withList(c, fn, done) {
    var cb = c.querySelector('[role="combobox"]');
    if (!cb) return done();
    if (cb.getAttribute('aria-expanded') !== 'true') cb.click();
    setTimeout(function () {
      var lb = document.getElementById(cb.getAttribute('aria-controls'));
      var opts = lb ? Array.prototype.slice.call(lb.querySelectorAll('[role="option"]')) : [];
      if (!fn(opts) && cb.getAttribute('aria-expanded') === 'true') cb.click();
      done();
    }, 0);
  }

  /* a picker's choices, read once (the picture dropdown is opened while hidden, so nothing shows) */
  function ctlValues(c, cb) {
    if (c.tagName === 'SELECT') return cb(Array.prototype.map.call(c.options, function (o) { return o.value; }));
    if (c.qbValues) return cb(c.qbValues);
    /* opening it redraws Kaching, which runs this again: those calls wait for the same reading */
    if (c.qbWait) return c.qbWait.push(cb);
    /* a list that cannot be read twice stays a dropdown */
    c.qbTries = (c.qbTries || 0) + 1;
    if (c.qbTries > 2) return cb(null);
    c.qbWait = [cb];
    later(function (done) {
      c.setAttribute('data-qb-sz-reading', '');
      withList(c, function (opts) {
        c.qbValues = opts.map(function (o) { return o.dataset.value; });
        return false;
      }, function () {
        c.removeAttribute('data-qb-sz-reading');
        var vals = c.qbValues && c.qbValues.length ? c.qbValues : null;
        if (!vals) c.qbValues = null;
        c.qbWait.splice(0).forEach(function (f) { f(vals); });
        c.qbWait = null;
        done();
      });
    });
  }

  function ctlSet(c, v) {
    if (!c || ctlValue(c) === v) return;
    if (c.tagName === 'SELECT') {
      c.value = v;
      c.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    later(function (done) {
      withList(c, function (opts) {
        var o = opts.find(function (x) { return x.dataset.value === v; });
        if (o) o.click();
        return !!o;
      }, done);
    });
  }

  /* "Size 7 (Standard)" -> 7 / Standard; "Size 6" on a ball picker -> 6 / Women's; anything else as it is */
  function optLabel(name, v) {
    var m = v.match(/^size\s*(\d+)\s*(?:\((.+)\))?$/i);
    if (!m) return { big: v, sub: '' };
    var sub = m[2] ? m[2].replace(/^womens$/i, "Women's") : /ball/i.test(name) ? BALL_NAMES[m[1]] || '' : '';
    return { big: m[1], sub: sub };
  }

  function colourOf(v) {
    var parts = v.toLowerCase().split('/').map(function (p) { return COLOURS[p.trim()]; });
    return parts.every(Boolean) ? parts : null;
  }

  /* ball sizes largest first, clothing sizes XS to XXL, anything else in Kaching's order */
  function sortValues(vals) {
    var num = function (v) { var m = v.match(/^size\s*(\d+)/i); return m ? Number(m[1]) : null; };
    if (vals.every(function (v) { return num(v) !== null; })) return vals.slice().sort(function (a, b) { return num(b) - num(a); });
    var at = function (v) { return SIZE_ORDER.indexOf(v.toLowerCase()); };
    if (vals.every(function (v) { return at(v) > -1; })) return vals.slice().sort(function (a, b) { return at(a) - at(b); });
    return vals;
  }

  /* 'one' (a single choice: shown as text), 'dots' (every value a colour), 'text' (up to 8 short values) or null
     (stays a dropdown) */
  function kindOf(name, vals) {
    if (!vals || !vals.length) return null;
    if (vals.length === 1) return 'one';
    if (/colou?r/i.test(name) && vals.length <= 10 && vals.every(colourOf)) return 'dots';
    if (vals.length <= 8 && vals.every(function (v) { return optLabel(name, v).big.length <= 12; })) return 'text';
    return null;
  }

  function sentence(name) {
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  }

  var szId = 0;
  function buildPanel(specs, rest, ri, noun) {
    var p = document.createElement('div');
    p.className = 'qb-sz';
    if (ri >= 0) {
      p.dataset.ri = ri;
      var head = document.createElement('div');
      head.className = 'qb-sz__head';
      var kit = document.createElement('span');
      kit.className = 'qb-sz__kit';
      kit.textContent = noun + ' ' + (ri + 1);
      head.appendChild(kit);
      if (ri > 0) {
        var same = document.createElement('button');
        same.type = 'button';
        same.className = 'qb-sz__same';
        same.setAttribute('role', 'checkbox');
        same.textContent = 'Same as ' + noun + ' 1';
        head.appendChild(same);
      }
      p.appendChild(head);
      if (ri > 0) {
        var sum = document.createElement('p');
        sum.className = 'qb-sz__summary';
        p.appendChild(sum);
      }
    }
    specs.forEach(function (s) {
      var grp = document.createElement('div');
      grp.className = 'qb-sz__group';
      grp.dataset.name = s.name;
      grp.setAttribute('role', 'radiogroup');
      var lab = document.createElement('span');
      lab.className = 'qb-sz__label';
      lab.id = 'qb-sz-' + ++szId;
      lab.textContent = sentence(s.name);
      if (s.kind !== 'text') {
        var val = document.createElement('b');
        val.className = 'qb-sz__val';
        lab.appendChild(document.createTextNode(': '));
        lab.appendChild(val);
      }
      grp.setAttribute('aria-labelledby', lab.id);
      grp.appendChild(lab);
      p.appendChild(grp);
      if (s.kind === 'one') {
        grp.removeAttribute('role');
        return;
      }
      var opts = document.createElement('div');
      opts.className = 'qb-sz__opts' + (s.kind === 'dots' ? ' qb-sz__opts--dots' : '');
      /* the buttons share a grid whose column fits the longest label, so a row that wraps splits evenly (3 + 3) */
      var widest = Math.max.apply(null, s.vals.map(function (v) {
        var l = optLabel(s.name, v);
        return Math.max(l.big.length * 0.85, l.sub.length * 0.62);
      }));
      opts.style.setProperty('--qb-sz-min', Math.max(4.8, widest + 1.6).toFixed(1) + 'rem');
      sortValues(s.vals).forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'qb-sz__opt';
        b.setAttribute('role', 'radio');
        b.dataset.value = v;
        if (s.kind === 'dots') {
          var cs = colourOf(v);
          var dot = document.createElement('span');
          dot.className = 'qb-sz__dot';
          dot.style.background = cs.length > 1 ? 'linear-gradient(135deg, ' + cs[0] + ' 50%, ' + cs[1] + ' 50%)' : cs[0];
          b.appendChild(dot);
          b.setAttribute('aria-label', v);
          b.title = v;
        } else {
          var l = optLabel(s.name, v);
          var big = document.createElement('b');
          big.textContent = l.big;
          b.appendChild(big);
          if (l.sub) {
            var sub = document.createElement('span');
            sub.textContent = l.sub;
            b.appendChild(sub);
          }
          b.setAttribute('aria-label', l.sub ? v.replace(/\s*\(.*\)$/, '') + ', ' + l.sub : v);
        }
        opts.appendChild(b);
      });
      grp.appendChild(opts);
    });
    /* a picker left as a dropdown (Country) keeps its name above it */
    rest.forEach(function (name) {
      var r = document.createElement('span');
      r.className = 'qb-sz__label qb-sz__rest';
      r.textContent = sentence(name);
      p.appendChild(r);
    });
    return p;
  }

  function rowValues(g) {
    return ctlsOf(g).map(function (c) { return [c.dataset.name, ctlValue(c)]; });
  }

  function panelOf(g) {
    var n = g && g.nextElementSibling;
    return n && n.classList.contains('qb-sz') ? n : null;
  }

  function rowsOf(bar) {
    return Array.prototype.slice.call(bar.querySelectorAll('.kaching-bundles__bar-variant-selector-wrapper .kaching-bundles__bar-variant-selects'));
  }

  /* copies row 1's picks into a row that is "Same as Kit 1" */
  function follow(g, first) {
    rowValues(first).forEach(function (nv) {
      ctlSet(ctlsOf(g).find(function (c) { return c.dataset.name === nv[0]; }), nv[1]);
    });
  }

  /* shows what each picker holds now: the checked button (the only one reachable with Tab), a colour's name, the
     collapsed row's summary; a "Same as" row that drifted from row 1 is put back */
  function syncPanel(p, g, bar) {
    ctlsOf(g).forEach(function (c) {
      var grp = Array.prototype.find.call(p.querySelectorAll('.qb-sz__group'), function (x) { return x.dataset.name === c.dataset.name; });
      if (!grp) return;
      var v = ctlValue(c);
      var opts = grp.querySelectorAll('.qb-sz__opt');
      var any = Array.prototype.some.call(opts, function (b) { return b.dataset.value === v; });
      opts.forEach(function (b, i) {
        var on = b.dataset.value === v;
        if (b.getAttribute('aria-checked') !== String(on)) b.setAttribute('aria-checked', String(on));
        b.tabIndex = on || (!any && i === 0) ? 0 : -1;
      });
      var val = grp.querySelector('.qb-sz__val');
      if (val && val.textContent !== v) val.textContent = v;
    });
    var same = p.querySelector('.qb-sz__same');
    if (!same) return;
    var first = rowsOf(bar)[0];
    var on = p.hasAttribute('data-same');
    same.setAttribute('aria-checked', String(on));
    g.toggleAttribute('data-qb-sz-same', on);
    if (!on || !first) return;
    var sum = p.querySelector('.qb-sz__summary');
    var text = rowValues(first).map(function (nv) { return nv[1]; }).join(' · ');
    if (sum.textContent !== text) sum.textContent = text;
    /* not while picks are still queued: row 1 may not hold its new value yet */
    if (!queued && rowValues(first).join() !== rowValues(g).join()) follow(g, first);
  }

  /* once Kaching has taken a pick (after any picture-dropdown steps queued before), the bar's panels and the kit
     pictures are brought up to date at once, without waiting for the watcher's pause */
  function afterPick(p) {
    later(function (done) {
      setTimeout(function () {
        var bar = p.closest('.kaching-bundles__bar');
        if (bar) {
          bar.querySelectorAll('.qb-sz').forEach(function (x) {
            if (x.previousElementSibling) syncPanel(x, x.previousElementSibling, bar);
          });
        }
        var scope = p.closest('product-info, .product, .quick-add-modal__content');
        if (scope) kitTiles(scope);
        done();
      }, 30);
    });
  }

  function pick(p, b) {
    var g = p.previousElementSibling;
    var bar = p.closest('.kaching-bundles__bar');
    var name = b.closest('.qb-sz__group').dataset.name;
    var v = b.dataset.value;
    b.closest('.qb-sz__opts').querySelectorAll('.qb-sz__opt').forEach(function (x) {
      x.setAttribute('aria-checked', String(x === b));
      x.tabIndex = x === b ? 0 : -1;
    });
    ctlSet(ctlsOf(g).find(function (c) { return c.dataset.name === name; }), v);
    /* row 1: the rows that are "Same as Kit 1" follow */
    if (p.dataset.ri === '0' && bar) {
      rowsOf(bar).slice(1).forEach(function (r) {
        var rp = panelOf(r);
        if (rp && rp.hasAttribute('data-same')) ctlSet(ctlsOf(r).find(function (c) { return c.dataset.name === name; }), v);
      });
    }
    afterPick(p);
  }

  function onPanelClick(e) {
    var p = e.currentTarget;
    var b = e.target.closest('.qb-sz__opt, .qb-sz__same');
    if (!b) return;
    /* the bar is a <label> and Kaching listens on it: the click stays with the button */
    e.preventDefault();
    e.stopPropagation();
    if (b.classList.contains('qb-sz__opt')) return pick(p, b);
    var on = !p.hasAttribute('data-same');
    p.toggleAttribute('data-same', on);
    var bar = p.closest('.kaching-bundles__bar');
    if (on && bar) follow(p.previousElementSibling, rowsOf(bar)[0]);
    syncPanel(p, p.previousElementSibling, bar);
    afterPick(p);
  }

  /* arrow keys move along a row of buttons and pick, as in any radio group */
  function onPanelKey(e) {
    var b = e.target.closest('.qb-sz__opt');
    var step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
    if (!b || !step) return;
    var all = Array.prototype.slice.call(b.parentElement.children);
    var next = all[(all.indexOf(b) + step + all.length) % all.length];
    e.preventDefault();
    next.focus();
    pick(e.currentTarget, next);
  }

  function setupGroup(bar, g, ri, nRows) {
    var ctls = ctlsOf(g);
    if (!ctls.length) return;
    var vals = [];
    var left = ctls.length;
    ctls.forEach(function (c, i) {
      ctlValues(c, function (v) {
        vals[i] = v;
        if (--left === 0) place(bar, g, ctls, vals, nRows > 1 ? ri : -1);
      });
    });
  }

  function place(bar, g, ctls, vals, ri) {
    if (!g.isConnected) return;
    var specs = [];
    var rest = [];
    ctls.forEach(function (c, i) {
      var kind = kindOf(c.dataset.name || '', vals[i]);
      if (kind) specs.push({ name: c.dataset.name, vals: vals[i], kind: kind });
      else rest.push(c.dataset.name || '');
      /* hidden with an attribute: Kaching sets the class and value of its pickers, never this */
      c.toggleAttribute('data-qb-sz-off', !!kind);
    });
    var p = panelOf(g);
    if (!specs.length) {
      if (p) p.remove();
      return;
    }
    var sig = JSON.stringify([specs, rest, ri]);
    if (p && p.dataset.sig !== sig) {
      p.remove();
      p = null;
    }
    if (!p) {
      var noun = ctls.length > 1 ? 'Kit' : specs[0].kind === 'dots' ? 'Pair' : /^size\s*\d/i.test(specs[0].vals[0]) ? 'Ball' : 'Item';
      p = buildPanel(specs, rest, ri, noun);
      p.dataset.sig = sig;
      p.addEventListener('click', onPanelClick);
      p.addEventListener('keydown', onPanelKey);
      var first = rowsOf(bar)[0];
      if (ri > 0 && first && rowValues(first).join() === rowValues(g).join()) p.setAttribute('data-same', '');
      g.after(p);
    }
    g.toggleAttribute('data-qb-sz-empty', !rest.length);
    if (g.parentElement) g.parentElement.setAttribute('data-qb-sz-main', '');
    /* Kaching's line of option names ("Ball Size, Mat Size, User Type") goes: each group has its own name now */
    var host = g.closest('.kaching-bundles__bar-variants, .kaching-bundles__bundle-products__product');
    if (host) host.setAttribute('data-qb-sz', '');
    syncPanel(p, g, bar);
  }

  function sizeButtons(scope) {
    scope.querySelectorAll('.kaching-bundles__bar').forEach(function (bar) {
      var rows = rowsOf(bar);
      bar.querySelectorAll('.kaching-bundles__bar-variant-selects').forEach(function (g) {
        setupGroup(bar, g, rows.indexOf(g), rows.length);
      });
    });
  }

  /* scope: one Kaching app block (on the page from the start; Kaching fills it later), so pages without one, and
     the rest of the page, are never watched. A quick view brings a new block for each product. */
  function initSizes(scope) {
    if (!SZ || scope.qbSzReady) return;
    scope.qbSzReady = true;
    sizeButtons(scope);
    watchKaching(scope, function () { sizeButtons(scope); });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-qb-appcard]').forEach(initAppCard);
    /* products without the app card (no VIP/Guest prices) still get their kit pictures */
    (root || document).querySelectorAll('script.qb-kit-data').forEach(function (s) {
      var scope = s.closest('product-info, .product, .quick-add-modal__content') || document.documentElement;
      if (scope.querySelector('[data-qb-appcard]')) return;
      if (scope.dataset.qbKitReady) return;
      scope.dataset.qbKitReady = '1';
      kitTiles(scope);
      watchKaching(scope, function () { kitTiles(scope); });
    });
    /* option buttons wherever Kaching shows bars: the product page and quick view popups */
    (root || document).querySelectorAll('[id*="kaching_bundles_app_block"]').forEach(initSizes);
  }

  function start() {
    initAll(document);
    /* quick view popups load the product form on demand */
    document.querySelectorAll('quick-add-modal').forEach(function (m) {
      new MutationObserver(function () { initAll(m); }).observe(m, { childList: true, subtree: false });
      var c = m.querySelector('.quick-add-modal__content-info');
      if (c) new MutationObserver(function () { initAll(m); }).observe(c, { childList: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
